<template>
  <div>
    <StepForMobile
      :currentStep="3"
      :screenType="screenType"
      :title="this.$t('Sending & Filtering')"
    />
    <UploadProgress v-if="uploadStep === 3" />
  </div>
</template>

<script>
import UploadProgress from '@/components/CasualInterface/CasualUpload/UploadProgress.vue'
import StepForMobile from '@/components/WebsiteInterface/CommonComponents/StepForMobile.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ProgressWrapper',
  props: {
    screenType: String,
  },
  components: {
    StepForMobile,
    UploadProgress,
  },
    computed: {
        ...mapGetters(['uploadStep']),
    },
}
</script>
